import { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { getDateFromTimestamp } from '../utils/getDateFromTimestamp'
import Card from '../ui-elements/Card'
import Button from '../formfields/Button'

type Props = {
    stageProcessRecord: ObjectStringKeyAnyValue | null
    stageName: string
    customNextSteps: boolean
    nextSteps: ObjectStringKeyAnyValue | null
    onCompleteDefault: () => void
    onCompleteCustomNextStep: (stepId: string) => void
}

function ProcessSummaryNoChecklist({
    stageProcessRecord,
    stageName,
    customNextSteps,
    nextSteps,
    onCompleteDefault,
    onCompleteCustomNextStep
}: Props) {
    const { t } = useContext(GlobalContext)

    const startTimestamp = stageProcessRecord && stageProcessRecord['StartTimeStamp']
    const startedByUserDetails = stageProcessRecord && stageProcessRecord['startedByUserDetails']
    const startedByName = startedByUserDetails && (
        startedByUserDetails['FullName'] ||
        startedByUserDetails['email'] ||
        startedByUserDetails['cognito:username'] ||
        startedByUserDetails['username']
    )

    return (
        <div className={`w-full flex flex-col gap-6 items-center`}>
            <Card>
                <div className={`w-full flex flex-col gap-4 py-2`}>
                    <h3 className={`text-2xl font-righteous text-brandblue`}>{stageName}</h3>
                    {startTimestamp && (
                        <p className={`text-base text-gray-600`}>
                            {t('ProcessPages.ProcessSummaryNoChecklist.startedAt', {
                                time: getDateFromTimestamp(`${startTimestamp}`)
                            })}
                        </p>
                    )}
                    {startedByName && (
                        <p className={`text-base text-gray-600`}>
                            {t('ProcessPages.ProcessSummaryNoChecklist.startedBy', { name: startedByName })}
                        </p>
                    )}

                    <hr className={`border-gray-200`} />

                    <p className={`font-bold`}>{t('ProcessPages.ProcessSummary.nextSteps')}</p>

                    {!customNextSteps && (
                        <Button
                            onClick={onCompleteDefault}
                            text={t('ProcessPages.ProcessSummary.completeThisStage')}
                            fullwidth={true}
                            size={`big`}
                            variant={`primary`}
                        />
                    )}

                    {customNextSteps && nextSteps && Object.keys(nextSteps).map((step_id: string, index: number) => {
                        const thisStep = nextSteps[step_id]
                        return (
                            <Button
                                key={index}
                                onClick={() => onCompleteCustomNextStep(step_id)}
                                text={t('ProcessPages.ProcessSummary.nextStepName', { name: thisStep.NextStepName })}
                                fullwidth={true}
                                size={`big`}
                                variant={`primary`}
                            />
                        )
                    })}
                </div>
            </Card>
        </div>
    )
}

export default ProcessSummaryNoChecklist
